import type { AIAgentConfig, AIAgentPosition, AIAgentSize, AIAgentLanguage } from "./AIAgent.types";

export const AI_AGENT_WIDGET_TYPE = 12;

export const AI_AGENT_INBOX_SOURCE = 128;

export const AI_AGENT_SOURCE_TYPE = "AI_AGENT" as const;

export const AI_AGENT_MESSAGE_TYPE = "AI_AGENT" as const;

// Get default language from page context
const getDefaultLanguage = (): AIAgentLanguage => {
  const pageLang = window.EDRONE_CONTEXT?.language?.toLowerCase() || "en";
  if (pageLang.startsWith("pl")) return "pl";
  if (pageLang.startsWith("es")) return "es";
  if (pageLang.startsWith("pt")) return "pt";
  return "en";
};

export const defaultAIAgentConfig: AIAgentConfig = {
  design: {
    position: "bottom-right",
    size: "medium",
    margin: 20,
  },
  behavior: {
    language: getDefaultLanguage(),
  },
  rules: {
    device: 0,
  },
};

export const positionOptions: Array<{ name: string; value: AIAgentPosition }> = [
  { name: "Bottom Left", value: "bottom-left" },
  { name: "Bottom Right", value: "bottom-right" },
];

export const sizeOptions: Array<{ name: string; value: AIAgentSize }> = [
  { name: "Small", value: "small" },
  { name: "Medium", value: "medium" },
  { name: "Large", value: "large" },
];

export const deviceOptions: Array<{ name: string; value: number }> = [
  { name: "Desktop & Mobile", value: 0 },
  { name: "Mobile only", value: 1 },
  { name: "Desktop only", value: 2 },
];

export const languageOptions: Array<{ name: string; value: AIAgentLanguage }> = [
  { name: "English", value: "en" },
  { name: "Polski", value: "pl" },
  { name: "Español", value: "es" },
  { name: "Português", value: "pt" },
];

export const sizePixelMap: Record<AIAgentSize, number> = {
  small: 48,
  medium: 56,
  large: 64,
};
